<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<p class="part"><span href="#/OEBPS/toc#p01" id="pt1" title="Link target outside of Sample"><strong>PART ONE</strong></span></p>
<p class="part1"><span href="#/OEBPS/toc#p01" title="Link target outside of Sample"><strong>THE FIRST YEAR 1933</strong></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p01.vue?0daa4c88